export const REQUEST_RECORDINGS = 'REQUEST_RECORDINGS';
export const REQUEST_RECORDINGS_SUCCESS = 'REQUEST_RECORDINGS_SUCCESS';
export const REQUEST_RECORDINGS_FAILURE = 'REQUEST_RECORDINGS_FAILURE';

export const DELETE_RECORDING = 'DELETE_RECORDING';
export const DOWNLOAD_RECORDING = 'DOWNLOAD_RECORDING';
